import { $Q, $Qll } from "../utils/query-selector";
import { btnAddToCart } from "./cart";
import { setupCustomSelect } from './custom-select';

/**
 * Evaluates if is located in product page
 * and proceed to check window size
 */
export const stickyCart = () => {
  if (typeof window === 'undefined') return;

  if (!window.location.pathname.includes('product')) return;

  const lstOptionsProduct = $Qll('.main-product .js-option');
  const stickyCart = $Q('.sticky-cart');
  const button = $Q('.add-product-cart', $Q('.main-product'));

  if (!stickyCart || !button) return;

  initStickyOrProduct(stickyCart, lstOptionsProduct);
  interceptionSticky(button, stickyCart);
  setupCustomSelect(stickyCart);
}

/**
 * Creates the interceptor for the node
 * indicated in the parameter indicated as slide
 * @param {Node} element - element container slider
 * @param {Function} callback - callback init slider
 */
export const interceptionSticky = (element, sticky) => {
  const optionsRoot = { rootMargin: "0px", threshold: 0.2 };

  const intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sticky.classList.add('hidden-sticky');
        } else {
          sticky.classList.remove('hidden-sticky');
        }
      })
    },
    optionsRoot,
  );

  intersectionObserver.observe(element);
}

/**
 * The function sets an option based on a selected value from a list of options.
 * @param event - The event parameter is an object that represents an event that occurred in the
 * browser, such as a mouse click or a key press. It contains information about the event, such as the
 * target element and the type of event.
 * @param lstOptions - lstOptions is an array of objects that represent the options in a dropdown menu.
 * Each object has a "value" property that corresponds to the value of the option, and a "click" method
 * that is called when the option is selected.
 */
export const setOption = (event, lstOptions, isMainProduct = false) => {
  if (!isMainProduct) return;
  const option = lstOptions.find((element) => element.value === event.target.value);
  option.click();
}

/**
 * This function initializes a click event listener on a given scope and sets an option based on the
 * clicked element's class.
 * @param scope - The scope parameter is likely a DOM element that represents the container or parent
 * element for a set of options that the user can select from. The event listener is attached to this
 * element to listen for clicks on any of its child elements with the class "js-option".
 * @param lstOptions - It seems that `lstOptions` is a variable that holds an array of options. The
 * function `setOption` is called with the `event` and `lstOptions` as arguments when a click event is
 * triggered on an element with the class "js-option". The purpose of this function is not
 */
const initStickyOrProduct = (scope, lstOptions) => {
  btnAddToCart('.add-product-cart', scope);

  scope.addEventListener('change', (event) => {
    if (event.target.classList.contains("js-option")) {
      setOption(event, lstOptions, true);
    }
  })
}
